const SITE_PATHS = {
  ROOT: '/',
  AGREEMENT: '/agreement',
  LOANS_LISTING: '/loans',
  SIGN_IN: '/signin',
  CONFIRM_LOAN: '/confirmloan',
  LOAN: '/loan/',
  CHANGE_PASSWORD: '/changepassword',
  INVITE_PAGE: '/invite/:inviteId',
  SIGN_OUT: '/signout',
  SIGNIN_CALLBACK: '/signincallback',
  SOCIAL_CONNECTORS: '/social-connector',
  SOCIAL_CONNECTORS_CALLBACK: '/social-connector-callback',
  CONNECTED_SOCIAL_PROFILE: '/connected-social-profile',
  TERMS: '/terms',
  PRIVACY_POLICY: '/privacy',
  THANK_YOU: '/thankyou',
  BANKING: '/banking',
  BANKING_THANK_YOU: '/banking/thank-you',
  DEALER_IBV_PAGE: '/ibv/:clientId',
  UTILITY: '/utility',
  PAYROLL: '/payroll',
  PREFILL: '/prefill',
  LEADS_FROM_INVITE: '/leads/:inviteId',
  LEADS: '/leads',
  OFFER: '/offer',
  CHATBOT: '/chatbot',
  OAUTH: '/auth',
  STANDALONE: '/standalone',
};

export default SITE_PATHS;
